<template>
  <StepLayout
    :on-save="onSave"
    :is-busy-on-save="isBusyOnSave"
    :on-next="onNext"
    :is-busy-on-next="isBusyOnNext"
    :on-back="onBack"
    :is-disabled="isDisabled || containsEmojis"
    helpscout-article="65689bf4b754dd263795a638"
    step-navigation-button-data-ec="bulk_send_message_page"
  >
    <template v-slot:title>
      {{ $t('bulkSend.steps.message.title', { name }) }}
    </template>
    <p class="text-black mb-lg">{{ $t('bulkSend.steps.message.description') }}</p>
    <FloatingLabelTextArea
      :placeholder="$t('bulkSend.steps.message.addAMessage')"
      v-model="message"
      inputClasses="min-h-250"
      id="bulk-send-message"
      data-ec="bulk_send_message_page"
      data-et="message_textarea"
      :has-error="containsEmojis"
    />
    <PublicPageValidationError
      v-if="containsEmojis"
      :error-message="$t('bulkSend.steps.message.emojiNotSupported')"
    />
  </StepLayout>
</template>

<script>
import StepLayout from '@/components/ui/bulkSend/StepLayout.vue';
import FloatingLabelTextArea from '@/components/tailwind/forms/FloatingLabelTextarea.vue';
import { useGetters } from 'vuex-composition-helpers/dist';
import { computed, ref } from 'vue';
import { useBulkSendStepsNavigation } from '@/composables/bulkSend/steps';
import PublicPageValidationError from '@/components/tailwind/publicPages/PublicPageValidationError.vue';

export default {
  name: 'MessagePage',
  components: {
    PublicPageValidationError,
    FloatingLabelTextArea,
    StepLayout,
  },
  setup() {
    // @ts-ignore - useGetters has bad types
    const { bulkSend } = useGetters({ bulkSend: 'bulkSend/bulkSend' });

    const message = ref(bulkSend.value.message);

    const updateValue = computed(() => ({ message: message.value }));

    const containsEmojis = computed(() => (/\p{Extended_Pictographic}/u.test(message.value)));

    const {
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
    } = useBulkSendStepsNavigation(
      'bulkSend/updateBulkSend',
      updateValue,
    );

    return {
      bulkSend,
      message,
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
      containsEmojis,
    };
  },
  computed: {
    name() {
      return this.bulkSend.name;
    },
  },
};
</script>
